const middleware = {}

middleware['hide-legacy-pages'] = require('../middleware/hide-legacy-pages.ts')
middleware['hide-legacy-pages'] = middleware['hide-legacy-pages'].default || middleware['hide-legacy-pages']

middleware['live-preview'] = require('../middleware/live-preview.ts')
middleware['live-preview'] = middleware['live-preview'].default || middleware['live-preview']

middleware['needs-anonymous'] = require('../middleware/needs-anonymous.ts')
middleware['needs-anonymous'] = middleware['needs-anonymous'].default || middleware['needs-anonymous']

middleware['needs-authentication'] = require('../middleware/needs-authentication.ts')
middleware['needs-authentication'] = middleware['needs-authentication'].default || middleware['needs-authentication']

export default middleware
